import { generateChunkedPagePDF } from '../../../util/pdf.util'
import { loadBrandingImageForPdf } from '../../../util/pdfBrandingImage'
import { getReportFilename } from '../../../util/string.utils'
import {
  AI_RISK_REPORT_PDF_CHUNK_SELECTOR,
  AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_SELECTOR,
  AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_SELECTOR,
} from './data/constants'

const AI_RISK_REPORT_TITLE_ID = 'MENU.AI_RISK_REPORT'

export const buildAIRiskReportPdfFilename = ({ customerName, intl }) =>
  getReportFilename(customerName ?? '', AI_RISK_REPORT_TITLE_ID, undefined, intl)

export default async function downloadAIRiskReportPDF({ element, customerName, branding, intl }) {
  const title = intl.formatMessage({ id: AI_RISK_REPORT_TITLE_ID })
  const logo = await loadBrandingImageForPdf(branding)

  await generateChunkedPagePDF({
    element,
    chunkSelector: AI_RISK_REPORT_PDF_CHUNK_SELECTOR,
    keepWithNextSelector: AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_SELECTOR,
    pageBreakProtectedSelector: AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_SELECTOR,
    filename: buildAIRiskReportPdfFilename({ customerName, intl }),
    title,
    subtitle: customerName,
    logo,
  })
}
